/* Health Check shared tokens — the client form is the only part of EQUIPR a
   client ever sees, so it stays deliberately quiet. */
export const H = {
  page: "#F2EFE8", card: "#FFFFFF", panel: "#FBFAF7", sunken: "#F6F4EF",
  border: "#DAD5CA", control: "#C9C3B6", divider: "#E6E2D9",
  ink: "#141414", ink2: "#565149", ink3: "#8A857A",
  accent: "#FFD108", accentEdge: "#E0B800", accentInk: "#6B5600",
};

export const BANDS = {
  Green: { fill: "#E3F3E9", ink: "#0B4F2E", border: "#A9D9BE", dot: "#0E6B3F" },
  Amber: { fill: "#FFF7D1", ink: "#6B5600", border: "#E8D48A", dot: "#E0B800" },
  Red: { fill: "#FFE4DA", ink: "#8E1212", border: "#F3BFA8", dot: "#C23A00" },
};

export const MANROPE = { fontFamily: "Manrope, sans-serif" };
export const FOCUS =
  "focus-visible:outline-none focus-visible:border-[#141414] focus-visible:shadow-[0_0_0_3px_rgba(255,209,8,0.35)]";

export const FLAG_LABELS = {
  product_issue: "Product issue",
  walkthrough_wanted: "Walkthrough wanted",
  feature_request: "Feature request",
  growth_opportunity: "Growth opportunity",
  call_requested: "Call requested",
};

export const BandChip = ({ band, size = 12, testid }) => {
  const t = BANDS[band] || { fill: H.sunken, ink: H.ink3, border: H.border };
  return (
    <span data-testid={testid}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full font-bold uppercase whitespace-nowrap"
      style={{ fontSize: size, background: t.fill, color: t.ink, border: `1px solid ${t.border}`, letterSpacing: "0.06em" }}>
      {band || "Not checked"}
    </span>
  );
};

export const ddmon = (iso) => {
  if (!iso) return "—";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "—";
  const M = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${String(d.getDate()).padStart(2, "0")} ${M[d.getMonth()]} ${String(d.getFullYear()).slice(2)}`;
};
